import { useEffect, useRef, useState } from 'react'

const CHECK_INTERVAL = 5 * 60 * 1000 // 5 minutes

/**
 * Polls /health endpoint to detect version changes.
 * Returns true when a new version has been deployed.
 */
export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false)
  const [apiVersion, setApiVersion] = useState<string | null>(null)
  const initialVersion = useRef<string | null>(null)

  useEffect(() => {
    const apiUrl = import.meta.env.VITE_API_URL || ''

    const checkVersion = async () => {
      try {
        const res = await fetch(`${apiUrl}/health`)
        const data = await res.json()
        const version = data.version || null
        if (!version) return

        setApiVersion(version)

        if (initialVersion.current === null) {
          initialVersion.current = version
        } else if (version !== initialVersion.current) {
          setUpdateAvailable(true)
        }
      } catch {
        // Network error — ignore silently
      }
    }

    checkVersion()
    const interval = setInterval(checkVersion, CHECK_INTERVAL)
    return () => clearInterval(interval)
  }, [])

  const reload = () => window.location.reload()

  return { updateAvailable, apiVersion, reload }
}
